export const setMovie = (value=null) => {
    return { type: "SET_MOVIE", payload: value };
}